import * as React from 'react';
import { Translate } from '../../../../../../shared/LanguageService';
import history from '../../../../../../shared/history';
import BaseTab from './BaseTab';

type BrokersTabProps = {
    label: string;
};

const BrokersRoute = '/brokers';

let routes = [BrokersRoute];

function BrokersTab({ label, ...props }: BrokersTabProps) {
    function handleClick() {
        history.push(BrokersRoute);
    }

    return <BaseTab {...props} onClick={handleClick} label={label} route={BrokersRoute} />;
}

function TranslatedBrokersTab(props) {
    const label = Translate('header/nav/brokers');
    return <BrokersTab {...props} label={label} />;
}

TranslatedBrokersTab.routes = routes;

export default TranslatedBrokersTab;
